import React from 'react';
import PaginatorSize from '../../../../../components/PaginatorSize';
import CustomTable from './CustomTable';

interface ShowProps {
  dataCards: any[];
  selectedCategory: any;
  onCardClick: (pillar: any) => void;
  searchValue: string;
  onSearchChange: (v: string) => void;
  onOpenFilter: () => void;
  challenges: any[];
  page: number;
  totalPages: number;
  totalElements: number;
  pageSize: number;
  loading?: boolean;
  onPageChange: (page: number) => void;
  sortBy: string;
  sortDir: 'asc' | 'desc';
  onSort: (key: string) => void;
  challengeTotals: Record<string, number>;
  uniqueTypes: string[];
  filterStatus: string;
  filterType: string;
  modalStatus: string;
  modalType: string;
  setModalStatus: (v: string) => void;
  setModalType: (v: string) => void;
  setOpenFilter: (v: boolean) => void;
  setFilterStatus: (v: string) => void;
  setFilterType: (v: string) => void;
  onCreateEdit: () => void;
  onEditChallenge: (challenge: any) => void;
  onToggleStatus: (challengeId: string, currentStatus: boolean) => Promise<boolean>;
}

const Show: React.FC<ShowProps> = (props) => {
  return (
    <div className="padding-50">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <CustomTable
              data={props.challenges}
              page={props.page}
              totalPages={props.totalPages}
              onPageChange={props.onPageChange}
              sortBy={props.sortBy}
              sortDir={props.sortDir}
              onSort={props.onSort}
              searchValue={props.searchValue}
              onSearchChange={props.onSearchChange}
              onEditChallenge={props.onEditChallenge}
              onCreateEdit={props.onCreateEdit}
              onToggleStatus={props.onToggleStatus}
            />
            {props.challenges.length > 0 && (
              <PaginatorSize
                size={props.challenges.length}
                totalSize={props.totalElements}
                isLoading={props.loading}
                handleReset={() => props.onPageChange(1)}
                handleLoadMore={() => props.onPageChange(props.page + 1)}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Show; 